import type { PublicRouteClassifierContribution } from '#kernel/public-site/public-route-classifier-types.ts';

export default {
  id: 'pre-matter-lexi-advisor',
  paths: ['/ask-lexi/:token'],
} as const satisfies PublicRouteClassifierContribution;
